export const categorylessons: any[]= [
    { id:21,name: 'Artes' },
    { id:15,name: 'Ciencias Naturales' },
    { id:16,name: 'Ciencias Sociales' },
    { id:24,name: 'Lenguaje y Comunicación' },
    { id:14,name: 'Pensamiento Matemático' },
    { id:26,name: 'Idioma extranjero' },
    { id:616,name: 'Recreación / Psicomotricidad' },
    { id:13,name: 'Desarrollo Personal Social' },
    { id:42,name: 'Taller Extra-Programático' },
    { id:22,name: 'NEE' },
    { id:29,name: 'Tecnología' },    
    { id:481,name: 'Off Line' },
    { id:185,name: 'Sima Robot' }  
  ];